export default "__VITE_ASSET__Ch4bGHq$__"